import { render, staticRenderFns } from "./sale-create-form.component.vue?vue&type=template&id=b858a196&"
import script from "./sale-create-form.component.ts?vue&type=script&lang=ts&"
export * from "./sale-create-form.component.ts?vue&type=script&lang=ts&"
import style0 from "./sale-create-form.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports